import { render, staticRenderFns } from "./mediatargeting-table.vue?vue&type=template&id=0d644dae&scoped=true"
import script from "./mediatargeting-table.vue?vue&type=script&lang=js"
export * from "./mediatargeting-table.vue?vue&type=script&lang=js"
import style0 from "./mediatargeting-table.vue?vue&type=style&index=0&id=0d644dae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d644dae",
  null
  
)

export default component.exports